/**
 * Flag cascade rules for catalog taxonomy nodes.
 * Main list = isArchived == false (inactive nodes stay in the main list with a badge).
 */

import { flagsForArchiveWrite } from './catalogTaxonomyEffectiveState'

export { flagsForArchiveWrite }

/**
 * Normalize flags before form/save write (non-archive path).
 * Archive wins when isArchived === true, but showInNavigation intent is preserved.
 */
export function normalizeCatalogTaxonomyFlags({ isArchived, isActive, showInNavigation }) {
  if (isArchived === true) {
    return flagsForArchiveWrite({ showInNavigation })
  }

  return {
    isArchived: false,
    isActive: isActive === true,
    showInNavigation: showInNavigation === true,
  }
}

export function splitNodesByArchive(nodes = []) {
  const nonArchived = []
  const archived = []

  nodes.forEach((node) => {
    if (node?.isArchived === true) {
      archived.push(node)
    } else {
      nonArchived.push(node)
    }
  })

  return { nonArchived, archived }
}
